<div class="tooltip"
     (appClickOutside)="closeTooltip()"
     #tooltip>
  <span class="beak"
        *ngIf="hasBeak"
        #beak></span>
  <template *ngIf="isTemplateRef" [ngTemplateOutlet]="_content"></template>
  <div *ngIf="!isTemplateRef" [innerHTML]="_content"></div>
</div>
